module.exports = __webpack_public_path__ + "img/project2.86d869af.png";